module.exports = __webpack_public_path__ + "img/pauline-vos-untitled.6b69840.jpg";